<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinnerGuardar" [disabled]="!habilitarGuardar" title="Guardar" (click)="saveSolicitud()" type="button" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinnerGuardar" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Resultado {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudAtestFito}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitudAtestFito}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitudAtestFito}}" />
            </span>
        </h5>

        <!--FECHA PREVISTA INSPECCIÓN-->
        <div *ngIf="codigoTipoSolicitud === 'AC'" class="card card-accent-success animated fadeIn">
            <a class="card-header-a">
                <div class="card-header-buscador">
                    <i class="fa fa-list"></i> <strong>Fecha prevista de Inspección y Comunicación a Comunidad Autónoma</strong>
                </div>
            </a>
            <div class="card-body-detalle">
                <div class="row">
                    <div class="form-group group-filtros col-md-4">
                        <label class="col-form-label required-field" for="inpFecha">Fecha prevista de Inspección</label>
                        <p-calendar formControlName="FechaInspeccion" [ngClass]="displayFieldCssCal('FechaInspeccion')" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaInspeccion','required')">
                            Fecha prevista de Inspección es obligatoria
                        </div>
                    </div>

                    <div class="col-md-8" style="padding-top: 40px;">
                        <div class="form-group-0 float-right">
                            <div class="btn-group">
                                <button name="btnComunicarCa" [disabled]="!habilitarGuardar" class="btn btn-descarga btn-secondary btn-sm " type="button" title="Comunicar la fecha prevista de inspección a la Comunidad Autónoma" (click)="onComunicarCA()">
                                    <i class="fa fa-envelope-o"></i> Comunicar a C.A.
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--RESULTADO-->
        <div class="card card-accent-success animated fadeIn">
            <a class="card-header-a">
                <div class="card-header-buscador">
                    <i class="fa fa-list"></i> <strong>Resultado Atestación Fitosanitaria</strong>
                </div>
            </a>
            <div class="card-body-detalle">

                <div class="row">
                    <!--Tipo CA-->
                    <div *ngIf="codigoTipoSolicitud === 'CA'" class="form-group col-md-12">
                        <label class="col-form-label required-field" for="">Nombre Técnico Responsable</label>
                        <input formControlName="NombreTecResponsable" name="NombreTecResponsable" title="" [ngClass]="displayFieldCss('NombreTecResponsable')" class="form-control" id="inpNombre" type="text" value="" maxlength="150">

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NombreTecResponsable','required')">
                            Nombre Técnico Responsable es obligatorio
                        </div>
                    </div>
                    <!--Tipo AC-->
                    <div *ngIf="codigoTipoSolicitud === 'AC'" class="form-group col-md-12">
                        <label class="col-form-label required-field" for="">Agente de Control</label>
                        <input readonly formControlName="NombreAgenteControl" name="NombreAgenteControl" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="150">
                    </div>

                </div>
                <div class="row">

                    <div class="form-group col-md-4">
                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpFecha">Fecha Validez Inicio</label>
                        <p-calendar formControlName="FechaValidezInicio" [ngClass]="displayFieldCssCalNoSubmit('FechaValidezInicio')" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('FechaValidezInicio','required')">
                            Fecha Validez Inicio es obligatoria
                        </div>
                    </div>

                    <div class="form-group col-md-4">
                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="inpFecha">Fecha Validez Fin</label>
                        <p-calendar formControlName="FechaValidezFin" [ngClass]="displayFieldCssCalNoSubmit('FechaValidezFin')" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('FechaValidezFin','required')">
                            Fecha Validez Fin es obligatoria
                        </div>
                    </div>

                    <div class="form-group col-md-4">
                        <label class="col-form-label required-field" for="intEstado">Resultado Atestación Fitosanitaria</label>
                        <ng-select [items]="listResultadoSolicitud"
                                   bindLabel="Descripcion"
                                   bindValue="Id"
                                   formControlName="IdResultadoSolicitudAtestFito"
                                   loadingText="Cargando..."
                                   [readonly]="!listResultadoSolicitud || listResultadoSolicitud.length === 0"
                                   [loading]="!listResultadoSolicitud || listResultadoSolicitud.length === 0"
                                   notFoundText="Resultado no encontrado"
                                   placeholder="-- Seleccione un Resultado --"
                                   [ngClass]="displayFieldCssNgSelect('IdResultadoSolicitudAtestFito')"
                                   (change)="onSelectResultado()"
                                   clearAllText="Eliminar selección">
                            <!--<ng-template ng-option-tmp let-item="item">
                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                            </ng-template>-->

                            <ng-template ng-label-tmp let-item="item">
                                <img src="/assets/images/ResultadoAtestacion/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <img src="/assets/images/ResultadoAtestacion/{{item.Id}}.png" style="width:24px;vertical-align:middle" />
                                <span style="vertical-align:middle; margin-left: .5em">{{item.Descripcion}}</span>
                            </ng-template>

                        </ng-select>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdResultadoSolicitudAtestFito','required')">
                            Resultado es obligatorio
                        </div>
                    </div>
                </div>

                <!--OBSERVACIONES-->
                <div class="row group-filtros">
                    <div class="form-group col-md-12">
                        <label class="col-form-label" for="inpCodigo">Observaciones</label>
                        <textarea style="resize:none" formControlName="Observaciones"
                                  maxlength="1000" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                  value=""></textarea>

                    </div>
                </div>

                <!--FECHA FINALIZACION-->
                <div class="row">
                    <div *ngIf="fechaFinalizacion !== null" class="col-md-12">
                        <hr />
                        <h6>Fecha de la Decisión: {{fechaFinalizacion}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
